import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconFlipToBackComponent } from "./med-icon-flip-to-back.component";

@NgModule({
  declarations: [
    MedIconFlipToBackComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconFlipToBackComponent,
  ],
})
export class MedIconFlipToBackModule { }
